<script>
  import { Timeline } from 'element-ui'
  export default {
    name:'ElTimeline',
    extends:Timeline
  }
</script>
